// Copyright (c) 2017 Comsearch, Inc., All rights reserved

// DMS
export const MINUTES_RANGE = 'Minutes must be between 0 and 59'
export const SECONDS_RANGE = 'Seconds must be between 0 and 59.99'

// Latitude
export const LATITUDE_DEGREE_RANGE = 'Latitude degrees must be between -90 and 90'
export const LATITUDE_INVALID_FORMAT = 'Invalid latitude format'
export const LATITUDE_OUTSIDE_BOUNDS = 'Latitude value is outside of bounds.'

// Longitude
export const LONGITUDE_DEGREE_RANGE = 'Longitude degrees must be between -180 and 180'
export const LONGITUDE_INVALID_FORMAT = 'Invalid longitude format'
export const LONGITUDE_OUTSIDE_BOUNDS = 'Longitude value is outside of bounds.'

// corresponding pairs
export const MUST_HAVE_A_CORRESPONDING_LATITUDE = 'Must have a corresponding latitude'
export const MUST_HAVE_A_CORRESPONDING_LONGITUDE = 'Must have a corresponding longitude'
